import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
// import { Api } from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';
import groupList from '../../../Management/group/group.List.i18n'

//restful api
import { detect as wsfinder } from '@/service/api/wsfinder'


const default_opt = () => ({
  created_at_ed : moment(),
  created_at_sd : moment().subtract(1, 'month').startOf('d'),
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  target : "userinfo",
  cmd : "search",
  request : "wsf",
  offset : 0,
  limit : 10,
  adv : false,
  sk : '', "sv" : '', "skt" : '', "opt" : { },
  body : {
    sort : [ { name : "group_id" }, { name : "id", op : "desc" } ]
  }
})

const i18n_fields = {
  EN: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: 'Detect Time', sortable: false, thStyle : 'width: 20%' },
    { key: 'group', label: 'Group', sortable: false, thStyle: 'width: 10%' },
    { key: 'agent', label: 'Agent', sortable: false, thStyle: 'width: 30%' },
    { key: 'path', label: 'Path', sortable: false },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: '탐지 시간', sortable: false, thStyle : 'width: 20%' },
    { key: 'group', label: '그룹', sortable: false, thStyle: 'width: 10%' },
    { key: 'agent', label: '에이전트', sortable: false, thStyle: 'width: 30%' },
    { key: 'path', label: '경로', sortable: false },
  ]
}

export default {
  components: { DatePicker, vSelect, groupList },
  data: () => {
    return {
      so : default_opt(),
      chainGroup : false,
      codes,
      moment,
      group_name : '',
      custom,
      sync : { th : undefined, stop : false, interval : 15, enable : false },
      summaryData : { enable : 0, disable : 0, total : 0 },
      nbsp : "\u00A0",
      hide_del : true,
      year_modal: false,
      date_modal: false,
      date_check: undefined,
    }
  },
  computed: {
    fields () {
      return i18n_fields[this.i18n];
    },
    rowCount() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'group':
          delete this.so.opt.group_id
          this.group_name = '';
          this.chainGroup = false;
          break;
        default:
          break;
      }
      this.refresh()
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v, equal=false) {
      if(equal) {
        return { name : k, value : v, op : '=' }
      }
      else if(['level', 'mode', 'group_id'].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }

      return { name : k, value : `%${v}%`, op : 'like' }
    },
    reset() { this.so = default_opt(); this.group_name = undefined; this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getItems(ctx) {
      // 시작 및 마지막 날자 유무 판별
      if(!this.so.created_at_sd || !this.so.created_at_ed){
        this.date_modal = true;
        return this.date_modal
      }

      //조회기간 설정 [최대 1년]
      this.date_check = this.check_date();
      if(this.date_check > 365){
        this.year_modal = true;
        return this.year_modal
      }
      
      return this.load(ctx);
    },
    load(ctx = {}) {
      if(!this.view_detail !== false) {
        // not component
        this.summary()
      }
      
      let so = {
        body : { sort : [{name : 'id', op: 'desc'}], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: 10,
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      // if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

      //날짜 범위 오류로 +1 day 하여 백엔드로 보냄 [#5739]
      let re_created_at_ed = moment(this.so.created_at_ed).add(1, 'day').startOf('d')

      //일부 키워드 검색
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }
      if(this.so.created_at_ed) { so.body.and.push({ name : 'created_at', value : re_created_at_ed, op : '<='}); }
      if(this.so.created_at_sd) { so.body.and.push({ name : 'created_at', value : this.so.created_at_sd, op : '>='}); }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '='}); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'os_type':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'version':
              cond = parseInt(this.so.opt[k[i]]) > 0 ? this.set_op(k[i], this.so.opt[k[i]]) : this.set_op('', '')
              break;
            case 'mode':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'updated_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'updated_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return wsfinder.listDetect(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) {
      this.$router.push({ name : 'wsfinder_detect', params : { id: item.id } })
    },
    summary() {
      let and = [];
      if(this.group) { and.push({ name : 'group_id', value : this.group.id, op : '='}) }

      //날짜 범위 오류로 +1 day 하여 백엔드로 보냄 [#5739]
      let re_created_at_ed = moment(this.so.created_at_ed).add(1, 'day').startOf('d')

      wsfinder.summaryDetect({ and : and, or : [], sort : [], start_at : this.so.created_at_sd, end_at : re_created_at_ed })
        .then(rs => { this.summaryData = Object.assign(this.summaryData, { enable : rs.body.enable, disable : rs.body.disable, total : (rs.body.enable + rs.body.disable) }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    // 기간 범위 설정 [최대 1년]
    check_date(){
      let sd = moment(this.so.created_at_sd)
      let ed = moment(this.so.created_at_ed)

      let check_date = ed.diff(sd, 'day');
      return check_date
    },
    //검색어 초기화 기능
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
  },
  created() { console.log('detect.vue', 'created'); this.$root.$on('select', this.setGroup); },
  destroyed() { console.log('detect.vue', 'destroyed'); },
  mounted() {
    console.log('detect.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    // if(!this.view_detail !== false) {
    //   // not component
    //   this.summary()
    // }
  },
}